import { render, staticRenderFns } from "./SearchExpert.vue?vue&type=template&id=6e189340&scoped=true"
import script from "./SearchExpert.vue?vue&type=script&lang=ts"
export * from "./SearchExpert.vue?vue&type=script&lang=ts"
import style0 from "./SearchExpert.vue?vue&type=style&index=0&id=6e189340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e189340",
  null
  
)

export default component.exports